import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

export default dayjs;
export type {
  Ls,
  tz,
  utc,
  unix,
  Dayjs,
  extend,
  locale,
  isDayjs,
  UnitType,
  duration,
  QUnitType,
  OpUnitType,
  ConfigType,
  OptionType,
  PluginFunc,
  isDuration,
  FormatObject,
  UnitTypeLong,
  ConfigTypeMap,
  DayjsTimezone,
  UnitTypeShort,
  ManipulateType,
  UnitTypeLongPlural,
} from 'dayjs';
